import * as Yup from 'yup'

export const validationSchema = Yup.object({
  // glass_types: Yup.array().min(1),
})
